import {
  effect,
  inject,
  Injectable,
  Signal,
  signal,
  Injector,
  runInInjectionContext,
} from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { TiersService } from '../tiers/tiers.service';
import { DepositService } from '../deposit/deposit.service';
import { RoomListService } from '../room-list/room-list.service';
import { DepositWatcherService } from '../deposit/deposit-watcher.service';
import { DepositCheckerService } from '../deposit/deposit-checker.service';
import { OperatorService } from '../operator/operator.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private profileService = inject(ProfileService);
  private tiersService = inject(TiersService);
  private depositService = inject(DepositService);
  private depositChecker = inject(DepositCheckerService);
  private depositWatcher = inject(DepositWatcherService);
  private roomListService = inject(RoomListService);
  private operatorService = inject(OperatorService);
  private injector = inject(Injector);

  private initialisedSignal = signal<boolean | undefined>(undefined);

  initialise() {
    runInInjectionContext(this.injector, () => {
      effect(
        async () => {
          const initialised = this.profileService.initialised();
          if (initialised) {
            const userId = this.profileService.id;

            await Promise.all([
              this.depositChecker.initialise(
                this.operatorService.operatorId,
                this.operatorService.operatorPlatform,
              ),
              this.depositWatcher.initialise(),
              this.depositService.initialise(userId),
              this.tiersService.refresh(),
            ]);

            this.initialisedSignal.set(true);
          }
        },
        { allowSignalWrites: true },
      );
    });
  }

  get initialised(): Signal<boolean | undefined> {
    return this.initialisedSignal.asReadonly();
  }

  reset() {
    this.initialisedSignal.set(undefined);
  }
}
